 // eslint-disable-next-line
// export default('http://69.62.83.82:4040/images')
// eslint-disable-next-line
export default('https://api-pay.pitech.ae/images')
// export default('http://82.180.161.245:4040/images')
// export default('http://192.168.0.3:4040/images')
// export default('http://147.93.47.141:4040/images')
